import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { Story } from '../models/stories.entities';

@Component({
    selector: 'app-story',
    templateUrl: './story.component.html',
    styleUrls: ['./story.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StoryComponent implements OnInit, AfterViewInit {

	@Input()
	public story: Story;

	@Output()
	public storyClick: EventEmitter<number> = new EventEmitter();

	public ngOnInit(): void {

	}

	public ngAfterViewInit(): void {
		/**
		 * может понадобиться, чтобы отличать клик от прокручивания слайдера через клик/тач.
		 * Нужно, если экран < 1024, но при этом без тача (очень старый ноут)
		 *  */
		// const element = this.storyElement.nativeElement;
		// merge(
		// 	fromEvent(element, 'mousedown').pipe(map((event: MouseEvent) => event)),
		// 	fromEvent(element, 'mousemove').pipe(mapTo(0))
		// )
		// 	.pipe(
		// 		sample(fromEvent(element, 'mouseup'))
		// 	)
		// 	.subscribe((e: MouseEvent) => {
		// 		if (e?.button === 0) {
		// 			console.log('============story click');
		// 			//this.openStory(e as MouseEvent);
		// 		}
		// 	});
	}

	public handleStoryClick(): void {
		this.storyClick.next(this.story.storyId);
		this.story.isViewed = true;
	}


}
